import { useMemo } from 'react'
import { getPv, usePv } from '$logic/pv'
import { useCallStorage, useCallStoragePvMeta } from '$logic/call'
import { getUser, getUserDisplayName, useUser } from '$logic/users'
import { getUserImageUrl } from '$func/imageUrl'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { t } from '$i18n'

export function usePvCallOpponentInfo() {
  const {
    roomId: ongoingCallRoomId,
    callType,
    pvMeta: { roomId: pvMetaRoomId },
  } = useCallStorage()

  const roomId = callType === 'call' ? ongoingCallRoomId : pvMetaRoomId
  const { value: user } = useAsyncFunction(async () => {
    if (!roomId) return

    const pv = await getPv(roomId)
    if (!pv) return

    return await getUser(pv.to)
  }, [roomId])

  if (!user) return { id: undefined, image: undefined, name: undefined }
  return {
    id: user.id,
    image: getUserImageUrl(user),
    name: getUserDisplayName(user),
  }
}

export function useCallStatusText() {
  const pvMeta = useCallStoragePvMeta()

  return useMemo(() => {
    if (!pvMeta.roomId) return ''
    const { status, isCaller, state } = pvMeta

    if (state === 'none' || state === 'ongoing') return ''
    if (state === 'incoming') return t('call.incomingCall')
    if (state === 'outgoing') return t('call.connecting')

    // state: ended
    return status === 'successful'
      ? t('call.ended')
      : isCaller
        ? t(`call.${status}`)
        : status === 'canceled'
          ? t('call.canceled')
          : ''
  }, [pvMeta])
}
